import {CONST, ENUM, INTEGER, OBJECT, OPTIONAL, STRING} from '@acng/frontend-rubicon';
import {IMAGE_DATA} from '../../model';

/**
 * @typedef {Valid<typeof STOCK_ITEM>} StockItem
 */

const STOCK_ITEM = /* @__PURE__ */ (() =>
  OBJECT({
    type: ENUM(/** @type {const} */ (['Picture', 'Movie', 'Payttachment'])),
    article_id: INTEGER,
    valid_until: STRING,
    thumbnail: OPTIONAL(IMAGE_DATA),
  }))();

export const EVENTBUS_STOCK_ITEM = /* @__PURE__ */ (() =>
  OBJECT({
    type: CONST('stock-item'),
    item: STOCK_ITEM,
  }))();

export class NotFoundWithBlocked extends Error {

  /**
   * @param {Number} code
   */
  constructor(code) {
    super(`Not found: ${code}`);
    this.code = code;
  }

}
